import React, { useState, useCallback } from 'react';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { MLLocalDateUtil } from 'ml-portals-util-js';

import metadata from './AddIncidentFormComponent.metadata.json5';
import styles from './AddIncidentFormComponent.module.scss';

const AddIncidentFormComponent = (props) => {
    const {
        id,
        model: incidentToAdd,
        owners,
        onSave,
        onCancel,
        onModelChange,
        onIncidentCategoryChange
    } = props;

    const translator = useTranslator();

    const { onValidate: setComponentValidation, isComponentValid } = useValidation(id);

    const [showErrors, setShowErrors] = useState(false);

    const getMaxClaimDate = () => {
        const maxClaimDate = MLLocalDateUtil.date2LocalDate(new Date());
        maxClaimDate.day -= 1;
        return maxClaimDate;
    };

    const onValueChange = (value, path) => {
        switch (path) {
            case 'category': {
                onIncidentCategoryChange(value);
                break;
            }
            default:
                break;
        }
    };

    const formatDriverOptions = useCallback(() => {
        if (!owners) return [];
        return owners.map((owner) => ({
            code: owner.publicID,
            name: translator({
                id: owner.displayName,
                defaultMessage: owner.displayName
            })
        }));
    }, [owners, translator]);

    const isViolation = () => {
        return _.get(incidentToAdd, 'category.value.code') === 'violation';
    };

    const overrides = {
        addIncidentFormUpperRow: {
            columns: isViolation() ? ['3fr', '2fr', '2fr', '4fr'] : ['3fr', '2fr', '2fr', '2fr', '2fr']
        },
        incidentPersonDropdownSelect: {
            availableValues: formatDriverOptions(),
            value: _.get(incidentToAdd, 'person.publicID.value', null),
            onValueChange: (value) => {
                const person = owners.find((owner) => owner.publicID === value);
                _.set(incidentToAdd, 'person.value', person);
                onModelChange();
            }
        },
        incidentTypeDropdownSelect: {
            disabled: _.get(incidentToAdd, 'category.value') === undefined
        },
        incidentAmountContainer: {
            visible: !isViolation()
        },
        saveIncidentButton: {
            onClick: () => {
                if (isComponentValid) {
                    onSave(incidentToAdd);
                } else {
                    setShowErrors(true);
                }
            }
        },
        cancelAddIncident: {
            onClick: () => {
                onCancel(incidentToAdd);
            }
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={incidentToAdd}
            onValidationChange={setComponentValidation}
            onModelChange={onModelChange}
            onValueChange={onValueChange}
            showErrors={showErrors}
            classNameMap={styles}
        />
    );
};

AddIncidentFormComponent.propTypes = {
    id: PropTypes.string.isRequired,
    model: PropTypes.shape({}).isRequired,
    owners: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onModelChange: PropTypes.func.isRequired,
    onIncidentCategoryChange: PropTypes.func.isRequired
};

export default AddIncidentFormComponent;
